import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import $javelink_api from "../../api/services/javelink_api";
import axios from "axios";
import {TOKEN} from "../../storage/user";

export const fetchAppList = createAsyncThunk(
  "application/fetchAppList",
  async () => {
    try {
      const response = await $javelink_api.get("/applications/");
      return response.data;
    } catch (error) {
      throw error;
    }
  },
);

export const fetchIOSAppList = createAsyncThunk(
    "application/fetchIOSAppList",
    async (searchParams) => {
      try {
          const copiedParams = new URLSearchParams(searchParams);
          copiedParams.delete('content')
        const response = await $javelink_api.get(`/applications/?` + copiedParams);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
);

export const fetchAndroidAppList = createAsyncThunk(
    "application/fetchAndroidAppList",
    async (searchParams) => {
      try {
          const copiedParams = new URLSearchParams(searchParams);
          copiedParams.delete('content')
          const response = await axios.get("https://api.wwa-ios.com/android/api/android_apps/", {
              headers: {
                  Authorization: `Bearer ${TOKEN}`
              }
          });

        return response.data;
      } catch (error) {
        throw error;
      }
    },
);

const applicationSlice = createSlice({
  name: "application",
  initialState: {
    appList: [],
    appListLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAppList.pending, (state) => {
        state.appListLoading = true;
        state.appList = [];
      })
      .addCase(fetchAppList.fulfilled, (state, { payload }) => {
        state.appList = payload;
        state.appListLoading = false;
      })
      .addCase(fetchAppList.rejected, (state) => {
        state.appListLoading = false;
        state.appList = [];
      })

      .addCase(fetchIOSAppList.pending, (state) => {
        state.appListLoading = true;
        state.appList = [];
      })
      .addCase(fetchIOSAppList.fulfilled, (state, { payload }) => {
        state.appList = payload;
        state.appListLoading = false;
      })
      .addCase(fetchIOSAppList.rejected, (state) => {
        state.appListLoading = false;
        state.appList = [];
      })

      .addCase(fetchAndroidAppList.pending, (state) => {
        state.appListLoading = true;
        state.appList = [];
      })
      .addCase(fetchAndroidAppList.fulfilled, (state, { payload }) => {

          state.appList = payload;
        state.appListLoading = false;
      })
      .addCase(fetchAndroidAppList.rejected, (state) => {
        state.appListLoading = false;
        state.appList = [];
      })
  },
});

// export const { } = applicationSlice.actions;

export default applicationSlice.reducer;

export const applicationSelector = (state) => state.application;
